// extracted by mini-css-extract-plugin
export var button = "_jr-0";
export var donut = "_jr-1";
export var donutFill = "_jr-3";
export var donutTrack = "_jr-2";